import { render } from "./medicinal.vue?vue&type=template&id=7f2ec225&scoped=true"
import script from "./medicinal.vue?vue&type=script&lang=js"
export * from "./medicinal.vue?vue&type=script&lang=js"

import "./medicinal.vue?vue&type=style&index=0&id=7f2ec225&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2ec225"]])

export default __exports__